module.exports = __webpack_public_path__ + "static/NeutraText-Bold-80950e3ac318b9755f42ea62aeb947e2.ttf";